<template>
  <div class="zj-demo-chart">
    <zj-layout-container>
      <zj-layout-header>
        <h1 style="margin: 0rem 6rem;">基于消息通知的聊天室示例</h1>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable" ref="container">
          <ul class="zj-demo-chart-msg-list">
            <li v-for="msg in msgList" :key="msg.id">
              {{msg.content}}
            </li>
          </ul>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <div style="margin: 2rem 2rem;">
          <el-input v-model="sender" placeholder="发送人" style="width:15rem;"></el-input>
          <el-input v-model="text" placeholder="内容" style="margin: 0rem 1rem;width: auto;min-width:48rem;"></el-input>
          <el-button type="primary" @click="handleSend" style="margin: 0rem 1rem;">发送</el-button>
          <el-button type="primary" @click="handleClear" style="margin: 0rem 1rem;float:right;">清空</el-button>
        </div>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
//import ZJApp from '../../../../app'
export default {
    name: 'ZjDemoChat',
    controller: 'UI',
    action: 'Chat',
    data() {
        return {
          maxId: 1,
          sender: 'Web',
          text: '您好, Web!!!',
          msgList: []
        };
    },
    created() {
      this.sender = this.user.DisplayName;
      this.$notify.subscript('demo_chart', x=>this.onRecv(x));
      console.debug('Subscript: demo_chart');
    },
    destroyed() {
      this.$notify.unsubscript('demo_chart');
      console.debug('unsubscript: demo_chart');
    },
    methods: {
      onRecv(msg) {
        //console.log(msg.firstBlock().text);
        this.msgList.push({
          id: this.maxId++,
          content: msg.firstBlock().text
        });
        this.$nextTick(()=>{
          const container = this.$refs.container;
          container.scrollTop = container.scrollHeight;
        });
      },
      handleSend() {
        this.$notify.broadcase({
          key:'demo_chart',
          data: this.sender + '：' + this.text
        });
      },
      handleClear() {
        this.msgList.splice(0, this.msgList.length);
      }
    }
}
</script>

<style lang="scss" scoped>
ul.zj-demo-chart-msg-list,
ul.zj-demo-chart-button-bar {
    list-style: none;
    padding: 2rem 2rem;
    margin: 0;

    &>li {
      list-style: none;
      padding: 2rem 2rem;
      margin: 0;
    }
}
</style>